import type { I18n } from "@lingui/core";
import { en, zh, ms } from "make-plural/plurals";

export async function loadTranslation(locale: string, isProduction = true) {
  let data;
  if (isProduction) {
    data = await import(`../locales/${locale}/messages`);
  } else {
    data = await import(`@lingui/loader!../locales/${locale}/messages.po`);
  }

  return data.messages;
}

export function initTranslation(i18n: I18n): void {
  i18n.loadLocaleData({
    en: { plurals: en },
    zh: { plurals: zh },
    ms: { plurals: ms },
  });
}

/**
 * Convert a backend coalition color string to a CSS color. Port of LumiApp
 * lib/feature/news/utils/color_parser.dart:ColorParser.stringToColor.
 *
 * Accepts "#RRGGBB", "#AARRGGBB" (Flutter ARGB — alpha byte dropped for CSS), or
 * "R,G,B" (RGBO). Falls back to `fallback` for empty / invalid input.
 */
export function parseRGBToColor(color: string, fallback: string): string {
  if (!color) return fallback;

  try {
    if (color.startsWith("#")) {
      let hex = color.slice(1);
      if (hex.length === 8) hex = hex.slice(2); // ARGB -> RGB (drop leading alpha)
      return hex.length === 6 && /^[0-9a-fA-F]{6}$/.test(hex)
        ? `#${hex}`
        : fallback;
    }

    const parts = color.split(",").map((p) => p.trim());
    if (parts.length >= 3) {
      const [r, g, b] = parts.map((p) => parseInt(p, 10));
      if ([r, g, b].every((n) => Number.isFinite(n))) {
        return `rgb(${r}, ${g}, ${b})`;
      }
    }
    return fallback;
  } catch {
    return fallback;
  }
}
